interface LegendProps {
  isMobile?: boolean
  display: string
}

const Legend = ({ isMobile, display }: LegendProps) => {
  const showBoth = display === 'all'
  const showOrgs = display === 'orgs'
  const showInits = display === 'inits'
  const entity =
    display === 'orgs'
      ? 'a movement organization'
      : display === 'inits'
      ? 'an initiative'
      : 'an organization'

  const colorCode =
    display === 'orgs'
      ? ' colored by geographic scope'
      : display === 'inits'
      ? ' color coded by initiative type'
      : ' color coded by type'
  return (
    <div
      className={isMobile ? 'text-white text-[12px]' : 'text-white text-[16px]'}
    >
      <div className="mt-1 flex flex-row flex-wrap items-center">
        <div>
          <p className="mr-4">
            Each dot represents {entity}. Location is approximate. Dots are
            {colorCode}:{' '}
          </p>
        </div>
        <div className="flex flex-row items-center gap-3 flex-wrap">
          <div className="flex flex-row items-center">
            <div className="rounded-full flex bg-green min-w-[12px] max-w-[12px] h-[12px] mr-2"></div>
            <span>
              {showBoth
                ? 'Movement Organizations'
                : showOrgs
                ? 'Local'
                : 'Government'}
            </span>
          </div>

          <div className="flex flex-row items-center">
            <div className="rounded-full flex bg-mediumyellow min-w-[12px] max-w-[12px] h-[12px] mx-2"></div>
            <span>
              {showBoth ? 'Initiatives' : showOrgs ? 'State' : 'Academic'}
            </span>
          </div>

          {!showBoth && (
            <div className="flex flex-row items-center">
              <div className="rounded-full flex bg-brown min-w-[12px] max-w-[12px] h-[12px] mx-2"></div>
              <span>{showOrgs ? 'Regional' : 'Faith-based'}</span>
            </div>
          )}
          {!showBoth && (
            <div className="flex flex-row items-center">
              <div className="rounded-full flex bg-red min-w-[12px] max-w-[12px] h-[12px] mx-2"></div>
              <span>{showOrgs ? 'National' : 'Descendant Community'}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Legend
